import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";

import "./style/main.scss";

ReactDOM.render(<App />, document.getElementById("root"));
